// extracted by mini-css-extract-plugin
export default {"bitrate":"PulsePlayer_bitrate__VkE2k","ad_player":"PulsePlayer_ad_player__cIhx+","ad_pause_player":"PulsePlayer_ad_pause_player__aOc7t"};